import thunk from 'redux-thunk';
import reducer from './reducers';
import { createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';

const store = createStore(reducer, applyMiddleware(thunk));
const persister = persistStore(store);

export { store, persister };
